import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch } from 'hooks';
import { setLineOfBusiness } from 'reducers/commercialFormReducer';
import CommercialFormView from 'views/commercial_form/CommercialFormView';
import {
  VALIDATION_TYPE_COMMERCIAL_PROPERTY_CASUALTY,
  VALIDATION_TYPE_COMMERCIAL_AUTO,
} from 'variables/constants';

interface CommercialPolicyProps {
  policyUuid?: string;
  submissionId?: number;
  onProcessingComplete?: () => void;
  policyType?: string;
}

const CommercialPolicyView = ({
  policyUuid,
  submissionId,
  onProcessingComplete,
  policyType,
}: CommercialPolicyProps) => {
  useParams();
  const dispatch = useAppDispatch();

  // Set line of business based on policy type
  useEffect(() => {
    if (policyType === VALIDATION_TYPE_COMMERCIAL_PROPERTY_CASUALTY) {
      dispatch(setLineOfBusiness('Property & Casualty'));
    } else if (policyType === VALIDATION_TYPE_COMMERCIAL_AUTO) {
      dispatch(setLineOfBusiness('Auto'));
    }
  }, [policyType, dispatch]);

  // Call onProcessingComplete if provided
  useEffect(() => {
    if (onProcessingComplete) {
      onProcessingComplete();
    }
  }, [onProcessingComplete]);

  // For commercial policies, go directly to form (no quote processing needed)
  return <CommercialFormView />;
};

export default CommercialPolicyView;
